// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  height: 70px;
}

.social-button li {
  list-style: none;
}

.social-button li a {
  position: absolute;
  left: 0;
  display: inline-block;
  color: #fff;
  text-decoration: none;
  width: 70px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  font-size: 40px;
  border-radius: 50px;
  transition: 1s;
  transition-delay: 0s;
}

.social-button::before {
  content: url("https://cdn.pmlsound.com/paradigm/Paradigm_XR/icons8-share(1).svg");
  position: absolute;
  top: 0;
  left: 0;
  background: #374151;
  z-index: 10;
  width: 100%;
  height: 70px;
  text-align: center;
  line-height: 70px;
  font-size: 40px;
  border-radius: 50px;
  transition: 1s;
  transition-delay: .5s;
}

.social-button:hover li a {
  transform: rotate(-360deg);
  transition-delay: .5s;
}

.social-button:hover::before {
  transition-delay: 0s;
  width: 70px;
}

.social-button li:nth-child(1) a {
  background: #3b5998;
}

.social-button:hover li:nth-child(1) a {
  left: calc((70px + 25px) * 1);
}

.social-button li:nth-child(2) a {
  background: #55acee;
}

.social-button:hover li:nth-child(2) a {
  left: calc((70px + 25px) * 2);
}

.social-button li:nth-child(3) a {
  background: #dd4b39;
}

.social-button:hover li:nth-child(3) a {
  left: calc((70px + 25px) * 3);
}

.social-button li:nth-child(4) a {
  background: #bb0000;
}

.social-button:hover li:nth-child(4) a {
  left: calc((70px + 25px) * 4);
}

.social-button li:nth-child(5) a {
  background: #f40083;
}

.social-button:hover li:nth-child(5) a {
  left: calc((70px + 25px) * 5);
}
`, "",{"version":3,"sources":["webpack://./src/promosApp/paradigm_promos/components/gooey_social_button/social_button.scss","webpack://./src/promosApp/paradigm_promos/components/gooey_social_button/social_button.css"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,QAAQ;EAAI,SAAS;EAEd,gCAAK;EAAI,YAAY;EAC/B,YAAA;ACGD;;AAEA;EDFC,gBAAA;ACID;;AAEA;EDHI,kBAAO;EACP,OAAO;EACP,qBAAW;EACX,WAAA;EACA,qBAAW;EAAG,WAAQ;EACtB,YAAY;EAAU,kBAAiB;EACvC,iBAAe;EACf,eAAe;EACf,mBAAc;EAEjB,cAAA;EACD,oBAAsB;ACQtB;;AAEA;EDNa,iFAAO;EAChB,kBAAY;EACZ,MAAA;EACA,OAAO;EAAO,mBAAY;EAC1B,WAAU;EAAY,WAAW;EACjC,YAAW;EACX,kBAAe;EACf,iBAAc;EACd,eAAA;EACH,mBAAA;EACD,cAAc;EAEV,qBAAqB;ACWzB;;ADTA;EAEW,0BAAI;ECaL,qBAAqB;ADX/B;;ACcA;EDXA,oBAAuB;EACpB,WAAM;ACcT;;ADZA;EACI,mBAAmB;ACevB;;ADbA;EACG,6BAA6B;ACgBhC;;ADdA;EACI,mBAAmB;ACiBvB;;ADfA;EACI,6BAA6B;ACkBjC;;ADhBA;EACI,mBAAmB;ACmBvB;;ADjBA;EACG,6BAA6B;ACoBhC;;ADlBA;EACI,mBAAmB;ACqBvB;;ADnBA;EACG,6BAA6B;ACsBhC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".social-button{\n    position: absolute;\n    top: 50%;   left: 50%;\n    transform: translate(-50%,-50%);\n    width: 550px;   height: 70px;\n}\n.social-button li{\n    list-style: none;\n}\n.social-button li a{\n    position: absolute;\n    left: 0;\n    display: inline-block;\n    color: #fff;\n    text-decoration: none;\n    width: 70px;  height: 70px;\n    text-align: center;   line-height: 70px;\n    font-size: 40px;\n    border-radius: 50px;\n    transition: 1s;\n    transition-delay: 0s;\n}\n.social-button::before{\n    content: url('https://cdn.pmlsound.com/paradigm/Paradigm_XR/icons8-share(1).svg');\n    // font-family: 'fontAwesome';\n    position: absolute;\n    top: 0;  left: 0;\n    background: #374151;\n    z-index: 10;\n    width: 100%;  height: 70px;\n    text-align: center;   line-height: 70px;\n    font-size: 40px;\n    border-radius: 50px;\n    transition: 1s;\n    transition-delay: .5s;\n}\n.social-button:hover li a{\n    transform: rotate(-360deg);\n    transition-delay: .5s;\n}\n.social-button:hover::before{\n    transition-delay: 0s;\n    width: 70px;\n}\n.social-button li:nth-child(1) a{\n    background: #3b5998;\n}\n.social-button:hover li:nth-child(1) a{\n   left: calc((70px + 25px) * 1);\n}\n.social-button li:nth-child(2) a{\n    background: #55acee;\n}\n.social-button:hover li:nth-child(2) a{\n   left: calc((70px + 25px) * 2);\n}\n.social-button li:nth-child(3) a{\n    background: #dd4b39;\n}\n.social-button:hover li:nth-child(3) a{\n    left: calc((70px + 25px) * 3);\n}\n.social-button li:nth-child(4) a{\n    background: #bb0000;\n}\n.social-button:hover li:nth-child(4) a{\n   left: calc((70px + 25px) * 4);\n}\n.social-button li:nth-child(5) a{\n    background: #f40083;\n}\n.social-button:hover li:nth-child(5) a{\n   left: calc((70px + 25px) * 5);\n}",".social-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 550px;\n  height: 70px;\n}\n\n.social-button li {\n  list-style: none;\n}\n\n.social-button li a {\n  position: absolute;\n  left: 0;\n  display: inline-block;\n  color: #fff;\n  text-decoration: none;\n  width: 70px;\n  height: 70px;\n  text-align: center;\n  line-height: 70px;\n  font-size: 40px;\n  border-radius: 50px;\n  -webkit-transition: 1s;\n  transition: 1s;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.social-button::before {\n  content: url(\"https://cdn.pmlsound.com/paradigm/Paradigm_XR/icons8-share(1).svg\");\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #374151;\n  z-index: 10;\n  width: 100%;\n  height: 70px;\n  text-align: center;\n  line-height: 70px;\n  font-size: 40px;\n  border-radius: 50px;\n  -webkit-transition: 1s;\n  transition: 1s;\n  -webkit-transition-delay: .5s;\n          transition-delay: .5s;\n}\n\n.social-button:hover li a {\n  -webkit-transform: rotate(-360deg);\n          transform: rotate(-360deg);\n  -webkit-transition-delay: .5s;\n          transition-delay: .5s;\n}\n\n.social-button:hover::before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  width: 70px;\n}\n\n.social-button li:nth-child(1) a {\n  background: #3b5998;\n}\n\n.social-button:hover li:nth-child(1) a {\n  left: calc((70px + 25px) * 1);\n}\n\n.social-button li:nth-child(2) a {\n  background: #55acee;\n}\n\n.social-button:hover li:nth-child(2) a {\n  left: calc((70px + 25px) * 2);\n}\n\n.social-button li:nth-child(3) a {\n  background: #dd4b39;\n}\n\n.social-button:hover li:nth-child(3) a {\n  left: calc((70px + 25px) * 3);\n}\n\n.social-button li:nth-child(4) a {\n  background: #bb0000;\n}\n\n.social-button:hover li:nth-child(4) a {\n  left: calc((70px + 25px) * 4);\n}\n\n.social-button li:nth-child(5) a {\n  background: #f40083;\n}\n\n.social-button:hover li:nth-child(5) a {\n  left: calc((70px + 25px) * 5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
